import {IStore} from "modules/types/store";
import {createSelector} from "reselect";
import {IRewardStat} from "modules/actions/rewardStats";

const defaultReward: IRewardStat = {
	reward: "streak_5",
	earnedPercentage: 0,
	rarity: "Rare",
	color: "#a442f1",
};
export const getRewardsStore = (store: IStore) => store.rewards;

export const getRewardsStats = createSelector([getRewardsStore], (store) => store.rewards);

export const getRewardStatsByName = createSelector(
	[getRewardsStats],
	(rewards) => (reward: string) => rewards.find((it) => it.reward === reward) || defaultReward
);
